module.exports = __webpack_public_path__ + "media/standardized_tests/important_dates_title-d8f35f8d.jpg";